import isEqual from 'lodash/isEqual'

export default function shippingOptions(state = [], action) {
  switch (action.type) {
    case 'RECEIVE_SHIPPING_OPTIONS': {
      const getSortedKeys = options => options.map(opt => opt.key).sort()
      const areSameOptions = isEqual(getSortedKeys(state), getSortedKeys(action.payload))
      const selectedOption = areSameOptions
        ? state.find(option => option.selected)
        : getCheapestOption(action.payload)

      return action.payload.map(option => {
        if (option.key === selectedOption.key) {
          return { ...option, selected: true }
        }

        return { ...option, selected: false }
      })
    }

    case 'CHANGE_SHIPPING_OPTION': {
      return state.map(option => {
        if (option.key === action.payload.key) {
          return { ...option, selected: true }
        }

        return { ...option, selected: false }
      })
    }

    default: {
      return state
    }
  }
}

export function getChosenShippingOption(state) {
  const chosenShippingOption = state.find(option => option.selected)
  return chosenShippingOption || state[0] || { key: null }
}

export function getFulfilledShippingOption(order) {
  return {
    description: order.fulfillment_method_description,
    details: order.fulfillment_method_ship_time,
  }
}

function getCheapestOption(shippingOptions) {
  let cheapest = shippingOptions[0]

  for (let i = 1; i < shippingOptions.length; i += 1) {
    const cheapestAmount = parseFloat(cheapest.base_amount)
    const currentAmount = parseFloat(shippingOptions[i].base_amount)
    if (currentAmount < cheapestAmount) {
      cheapest = shippingOptions[i]
    }
  }

  return cheapest
}
